import { render, staticRenderFns } from "./menutree.vue?vue&type=template&id=22eb0559&"
import script from "./menutree.vue?vue&type=script&lang=js&"
export * from "./menutree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports